var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74487 20.9375C9.37949 21.521 10.2131 21.875 11.1261 21.875C12.0391 21.875 12.8727 21.521 13.5074 20.9375M16.5261 8.75C16.5261 7.25816 15.9572 5.82742 14.9445 4.77252C13.9318 3.71763 12.5583 3.125 11.1261 3.125C9.69395 3.125 8.32044 3.71763 7.30774 4.77252C6.29504 5.82742 5.72612 7.25816 5.72612 8.75C5.72612 11.647 5.02454 13.6306 4.24081 14.9426C3.57973 16.0493 3.24919 16.6026 3.26131 16.757C3.27473 16.9279 3.30949 16.9931 3.44171 17.0952C3.56113 17.1875 4.09945 17.1875 5.17608 17.1875H17.0761C18.1528 17.1875 18.6911 17.1875 18.8105 17.0952C18.9427 16.9931 18.9775 16.9279 18.9909 16.757C19.003 16.6026 18.6725 16.0493 18.0114 14.9426C17.2277 13.6306 16.5261 11.647 16.5261 8.75Z",
    stroke: "#6C737F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationImg);
export default __webpack_public_path__ + "static/media/NotificationImg.694ecb74d7a5ecf39fc6e8374d0f17d5.svg";
export { ForwardRef as ReactComponent };